<template>
  <div class="" style="min-height: 150px">
    <div
      style="text-align: justify; overflow-wrap: break-word"
      v-if="!customView && !isExpedientesComponent && !isFormComponent"
    >
      <div class="container" v-html="html"></div>
    </div>
    <div class="dinamic" v-if="customView">
      <component v-bind:is="customView"></component>
    </div>

    <DropdownComponent
      v-if="isDropdownComponent"
      titulo="Info Agentes"
      columnas="1"
      :data="[
        {
          title: 'Asignaciones Familiares',
          link: 'https://sites.google.com/view/procesosrecursoshumanos/asignaciones-familiares?authuser=0',
          desc: '',
        },

        {
          desc: `
            <!-- LISTADO TRAMITES -->
  <ul class='list-unstyled'>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Adicional Sistema Computo de Datos </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Bonificación por Título </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>Bonificación por inhabilitación de título </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Extensión horaria y productividad </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>Manejo de fondos </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Subrogancia</a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Bonificación por zona desfavorable</a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>
          Suplemento remunerativo no bonificable para autoridades no
          escalafonadas</a
        >
      </div>
    </li>
  </ul>
          `,
          title: 'Adicionales',
        },
        {
          desc: `  <ul class='list-unstyled'>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Comisión </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>Transferencia </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Cambio de agrupamiento </a>
      </div>
    </li>
  </ul>`,
          title: 'Movimiento del Personal',
        },
        {
          desc: `
            <ul class='list-unstyled'>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>
          Licencia Anual reglamentaria (Incluir pago LAR por Cese)</a
        >
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Licencia para tratamiento de la salud</a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Licencia Sin Goce de Haberes</a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>Licencia gremial </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>Licencia por Asuntos Familiares </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>Licencia por Maternidad y Adopción </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>
          Licencias para estudio y actividad cultural en el país o en el
          extranjero</a
        >
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>Licencia por Razones Particulares </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Licenica por Actividad Deportiva</a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>
          Licencia del agente Candidato/Electo Titular a cargo de representación
          política</a
        >
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Permisos para estudio</a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Permiso de Salida</a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'>Justificación de Inasistencia </a>
      </div>
    </li>
  </ul>
          `,
          title: 'Licencias',
        },
        {
          desc: `
            <ul class='list-unstyled'>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='?uid=CUMV-jubilacion-ordinaria' class='fac-a'>Jubilacion Ordinaria </a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Fallecimiento</a>
      </div>
    </li>
    <li>
      <div class='fac-a'>
        <span
          class='material-symbols-outlined text-ptn-color-gsj-brand fac-span'
        >
          description
        </span>
        <a href='' class='fac-a'> Renuncia</a>
      </div>
    </li>
    
  </ul>
          `,
          title: 'Desvinculación del Estado',
        },
        {
          desc: '',
          title: 'Consulta de Activo',
        },
      ]"
    />
    <FormComponent v-if="isFormComponent" />
    <ExpedientesComponent
      v-if="isExpedientesComponent"
      :filtros="{ site: 'dlc.siged.consulta.exp' }"
    />

    <div class="text-center pt-4">
      <p>
        <button v-on:click="back" class="btn btn-secondary text-uppercase">
          Volver
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ExpedientesComponent from "./components/resources/ExpedientesComponent.vue";
import FormComponent from "./components/resources/FormComponent.vue";
import DropdownComponent from "./components/resources/DropdownComponent.vue";

export default {
  name: "InfoView",
  props: {
    uid: String,
    filtros: Object,
  },
  data() {
    return {
      html: null,
      customView: false,
      isExpedientesComponent: false,
      isFormComponent: false,
      isDropdownComponent: false,
    };
  },
  methods: {
    back() {
      history.back();
    },
  },
  mounted() {
    if (this.uid === "CUMV-VIEW-FormComponent") {
      this.isFormComponent = true;
    } else if (this.uid === "CUMV-VIEW-ExpedientesComponent") {
      this.isExpedientesComponent = true;
    } else if (this.uid === "CUMV-VIEW-DropdownComponent") {
      this.isDropdownComponent = true;
    } else if (this.uid.includes("CUMV-"))
      switch (this.uid) {
        case "CUMV-firmadigital": {
          this.html = `<section class="container">
            <h2>Firma Digital</h2>
            <h5>¿PARA QUE SIRVE?</h5>
            <p> &nbsp Hace posible que un documento electrónico que sea "firmado digitalmente", tenga el mismo valor legal que el firmado de puño y letra en papel. <br>
            &nbspSi para establecer su voluntad sobre un documento en papel, se estampa una firma de puño y letra (firma holográfica) para su identificación, de modo similar puede hacerlo con una firma digital en un documento electrónico. Esto además permite detectar cualquier alteración producida posteriormente.</p>
            <section><div class='container'><div class='row row-cols-1 g-4'><div class='col'><div class='card'><div class='card-body p-md-1 d-flex flex-md-row align-items-md-center flex-column'><div class='contenedor-icono d-inline-flex align-items-center justify-content-center flex-shrink-0 me-3'><svg class='ptn-i-documento text-ptn-color-gsj-2' viewBox='0 0 512 512'> <path d='m170 379l172 0 0-32-172 0z m0-91l172 0 0-32-172 0z m-53 181c-8 0-16-3-22-9-6-7-10-14-10-23l0-362c0-9 4-16 10-23 6-6 14-9 22-9l193 0 117 116 0 278c0 9-4 16-10 23-6 6-14 9-22 9z m177-295l0-99-177 0 0 362 278 0 0-263z m-177-99l0 99 0-99 0 362z'></path> </svg><!--v-if--></div><!--v-if--><h3 class='card-title m-md-0 px-md-4 h6 text-uppercase' style='text-align: justify;'><a href='https://tramite.sanjuan.gob.ar/tramite/d/426' target='_blank' class='stretched-link'>Guía de Trámites</a></h3></div></div></div><!--v-if--></div><div class='py-4'><p style='text-align: justify;'></p></div></div></section>
            </section>`;
          break;
        }
        case "CUMV-jubilacion-ordinaria": {
          this.html = ` <section class="container">
    <h2 >JUBILACIÓN ORDINARIA</h2>
    <p>
      La Jubilación Ordinaria (JOR) es el beneficio previsional dirigido a
      mujeres y hombres que hayan alcanzado los requisitos de edad y años de
      servicios con aportes, según lo establece la legislación vigente. De
      acuerdo al Art. 19° Ley Nacional N° 24.241 los requisitos necesarios para
      acoger el beneficio de Jubilación Ordinaria, son: <br />
      <ol>
      <li>Edad: 
      <ul>
      <li> Hombres: 65 años de edad.</li>
      <li>Mujeres: 60 años de edad.</li>
      </ul>
      </li>
      <li>
      Servicios: Acreditar 30 años de servicios con aportes computables en uno o
      más regímenes comprendidos en el sistema de reciprocidad. Si en el momento
      de obtener la jubilación la persona excede la edad requerida, puede
      compensar un (1) año de servicio por cada dos (2) años de edad excedente.
      Por ejemplo, si una mujer se jubila con 62 años (2 años más de los
      exigidos por Ley) podrá jubilarse con 29 años de aportes. Las mujeres
      podrán optar por continuar su actividad laboral hasta los 65 años de edad.
      </li>
      </ol>  
    </p>
    <img  class="d-block img-fluid my-5" src="https://sanjuan.gob.ar/img/hacienda/rrhh/procesosJubilacionOrdinaria.jpg"/>
    <a
      type="button"
      class="btn btn-secondary me-3 my-3"
      target="_blank"
      href="https://tramite.sanjuan.gob.ar/tramite/d/440"
    >
      Link al Trámite
    </a>
    <a
      type="button"
      class="btn btn-secondary"
      target="_blank"
    >
      Acceso a Mapa Documental
    </a>
  </section>`;
          break;
        }
        case "CUMV-accidente-profesional": {
          this.html = `
<h2 class="pt-5">¿Sabés qué hacer ante un accidente o enfermedad profesional?</h2>
    <p>La ley 24557 obliga a contar con los servicios de una Aseguradora de Riesgos del Trabajo (ART).</p>
    <p><strong>Accidente de trabajo:</strong> Cualquier acontecimiento súbito y violento que ocurra por el hecho o en ocasión del trabajo.</p>
    <p>Un Accidente de Trabajo se puede producir:</p>
    <ul>
        <li>En el lugar habitual de trabajo o en otro sitio o sede donde se va a cumplir la labor, fuera de la ciudad, de la provincia o en el exterior.</li>
        <li>"In Itinere" son aquellos que ocurren en el trayecto entre el lugar de trabajo y domicilio del trabajador.</li>
    </ul>
    <p><strong>Enfermedad profesional:</strong> Son aquellas causadas por la exposición del trabajador a un agente de riesgo, presente en el medio ambiente de trabajo. Las enfermedades profesionales se encuentran listadas en el Decreto 658/96 y modificatorios.</p>
    <p>SI SUFRÍS UN ACCIDENTE LABORAL O ENFERMEDAD PROFESIONAL DEBES DENUNCIARLO:</p>
    <ul>
        <li>Comunicándote telefónicamente a tu ART a través de su línea de atención gratuita, informando del Accidente, donde se te otorgará un N° de Siniestro y se te indicará a qué Centro Asistencial debes concurrir.</li>
        <li>También puedes dirigirte a un Centro Médico prestador de la ART donde recibirás atención médica y se efectuarán los trámites administrativos correspondientes.</li>
        <li>A través de tu empleador, quien tiene la responsabilidad de denunciarlo en la ART a la que se encuentra afiliado.</li>
    </ul>
    <p>IMPORTANTE:</p>
    <ul>
        <li>Recuerda tener disponible Razón social, nombre y D.N.I del trabajador accidentado.</li>
        <li>Si el accidente se produce "In Itinere", debes realizar una Exposición Policial, la cual se adjuntará al resto de la documentación que se envía.</li>
        <li>Tienes que recibir de la A.R.T todas las prestaciones que correspondan: asistencia médica y farmacéutica, prótesis y ortopedia, rehabilitación, recalificación profesional y prestaciones dinerarias.</li>
    </ul>          `;
        }
      }
    else {
      let params = {};
      if (this.filtros != null && this.filtros != "") {
        params = this.filtros;
      }
      params.uid = this.uid;

      axios
        .post(process.env.VUE_APP_API_URL, params)
        .then((response) => {
          this.html = response.data ? response.data.html : null;
          localStorage.setItem(this.uid, JSON.stringify(response));
        })
        .catch((error) => {
          if (!error.response) {
            console.log("Fuera de Linea");
            if (localStorage.getItem(this.uid)) {
              console.log("Cargando elementos de cache para " + this.uid);
              var resp = JSON.parse(localStorage.getItem(this.uid));
              this.html = resp.data ? resp.data.html : null;
            }
          }
        });
    }
  },
  components: { ExpedientesComponent, FormComponent, DropdownComponent },
};
</script>
